import './Error.css';

function Error() {

    return (
        <section className='bad-path'>
            <h3>Uh oh! This URL does not exist.</h3>
            <h4>Please search for an article or click Home in the top right to browse our home page.</h4>
        </section>
    )
}

export default Error;